import * as THREE from "three";

import Garden from '../../Garden';
import Bloom from '../Bloom';

export class BloomView extends THREE.Group implements GardenView {
    blooms: Array<Bloom> = [];

    constructor() {
        super();

        let rows = 4;
        let columns = 4;

        for (let y = 0; y < rows; y++) {
            for (let x = 0; x < columns; x++) {

                let index = (y * 4) + x;
                let preset = Garden.Presets[index];
                let bloom = new Bloom(preset);

                bloom.position.set(x * 4 - 6, 0, y * 4 - 6);

                bloom.reset();
                bloom.grow(2000, null);

                this.add(bloom);
                this.blooms.push(bloom);
            }
        }
    }

    progress(value) {
        this.blooms.forEach((bloom) => {
            bloom.growing = false;
            bloom.materials.forEach((material) => {
                material.uniforms.progress.value = value;
            });
        });
    }

    update(time) {
        this.blooms.forEach((bloom) => {
            bloom.update(time);
        })
    }
}